import { Pedigree } from 'api/query/animal/pedigree';

/**
 * Recursive function to collect all nested children.
 * @param child
 */
const getKids = (child: Pedigree): any => {
  const a = [child];
  if (child.children && child.children.length) {
    child.children.forEach((kid) => {
      a.push(...getKids(kid));
    });
  }
  return a;
};

/**
 * Recursively gets the child element of the animal that is positioned the heighest in the chart (the lowest x offset).
 *
 * If no children exist, return the current child.
 * @param child
 */
export const getChild = (child: Pedigree): any => {
  if (child.children && child.children.length) {
    const allNestedChildren: Pedigree[] = [];
    allNestedChildren.push(...getKids(child));

    const theXpos = Math.min(...allNestedChildren.map((o: any) => o.x));
    return allNestedChildren.find((o: any) => o.x === theXpos);
  }
  return child;
};
